import { render, staticRenderFns } from "./TodoImprimBook.vue?vue&type=template&id=6f69bdb6&scoped=true&"
import script from "./TodoImprimBook.vue?vue&type=script&lang=js&"
export * from "./TodoImprimBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69bdb6",
  null
  
)

export default component.exports